import React, { useState, useEffect } from "react";
import { useAuth } from "../../AuthContext";
import { Container, Navbar, Nav, Button } from "react-bootstrap";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../Config";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../Pages/Company/Company.css";

const Header_Finance = ({ rsaMode }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);

  // Logo/theme only on RSA Finance routes — not on Charging Report / Upload
  const onRsaSection =
    location.pathname.startsWith("/Finance/RSA") ||
    (rsaMode === true && location.pathname.startsWith("/Finance/"));

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) setUserData(user);
  }, []);

  const handleLogout = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}Retail_Logout`,
        { userId: userData?.userId },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.responseCode === "0000") {
        logout();
        sessionStorage.removeItem("user");
        navigate("/");
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <Navbar
      expand="lg"
      sticky="top"
      className={`co-navbar py-2 mb-3${onRsaSection ? " co-page--rsasale" : ""}`}
    >
      <Container fluid="xl">
        <Navbar.Brand
          as={NavLink}
          to={onRsaSection ? "/Finance/RSA_Report" : "/Report"}
          className="d-flex align-items-center gap-2"
        >
          {onRsaSection ? (
            <img
              src="/RSA_Pakistan_Logo.png"
              className="co-rsa-logo"
              alt="RSA Pakistan"
            />
          ) : (
            <img src="../Webdoc_Logo.webp" style={{ width: "84px" }} alt="logo" />
          )}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="finance-navbar" />
        <Navbar.Collapse id="finance-navbar">
          <Nav className="me-auto gap-1 mt-2 mt-lg-0 align-items-lg-center">
            <Nav.Link as={NavLink} to="/Finance/RSA_Report">
              <i className="bi bi-shield-check me-1" />
              RSA Reporting
            </Nav.Link>
            <Nav.Link as={NavLink} to="/Report">
              <i className="bi bi-file-earmark-bar-graph me-1" />
              Charging Report
            </Nav.Link>
            <Nav.Link as={NavLink} to="/Upload">
              <i className="bi bi-upload me-1" />
              Upload
            </Nav.Link>
          </Nav>

          <div className="d-flex flex-column flex-lg-row align-items-lg-center gap-2 mt-3 mt-lg-0">
            {userData ? (
              <>
                <span
                  className="badge text-bg-light border text-dark px-3 py-2 text-truncate"
                  style={{ maxWidth: "220px" }}
                >
                  <i className="bi bi-person-circle me-1" />
                  {userData?.name || userData?.email}
                </span>
                <Button variant="outline-danger" size="sm" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right me-1" />
                  Logout
                </Button>
              </>
            ) : (
              <Nav.Link href="/">Login</Nav.Link>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header_Finance;
